import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { TenantProvider } from './contexts/TenantContext';
import { useTheme } from './hooks/useTheme';
import WelcomeScreen from './components/WelcomeScreen';
import LoadingScreen from './components/LoadingScreen';
import ErrorScreen from './components/ErrorScreen';
import AdminScreen from './components/AdminScreen';
import ChatScreen from './components/screens/ChatScreen';
import TestImport from './components/screens/TestImport';
import { useTenant } from './hooks/useTenant';
import { getTenantFromHost } from './lib/tenant';

/**
 * Sanctuary
 * Version: 0.0.1
 * Last Updated: July 2025
 * Changes: Migrated to new database architecture with separated tables for themes, assets, and configurations
 */

const AppContent: React.FC = () => {
  const { tenant, isLoading, error } = useTenant();
  const currentTenant = getTenantFromHost();
  
  // Apply theming
  useTheme();

  console.log('🎯 App State:', { 
    tenant: tenant?.id, 
    isLoading, 
    error 
  });

  // Show admin screen for admin subdomain
  if (currentTenant === 'admin') {
    return <AdminScreen />;
  }

  if (isLoading) {
    return <LoadingScreen />;
  }

  if (error) {
    return <ErrorScreen error={error} onRetry={() => window.location.reload()} />;
  }

  return (
    <Routes>
      <Route path="/" element={<WelcomeScreen onGetStarted={() => {}} />} />
      <Route path="/chat" element={<ChatScreen />} />
      <Route path="/admin" element={<AdminScreen />} />
      <Route path="/test-import" element={<TestImport />} />
      <Route path="*" element={<ErrorScreen error="Page not found" onRetry={() => window.location.reload()} />} />
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <TenantProvider>
        <AppContent />
      </TenantProvider>
    </Router>
  );
};

export default App;